import { useEffect, useState } from 'react'

export type Theme = 'light' | 'dark'

const STORAGE_KEY = 'studio_theme'

/**
 * Shared theme state + toggle. Persists to localStorage and reflects onto
 * `document.documentElement.dataset.theme` so CSS custom properties pick it up.
 * Used by both the authenticated header (TopBar) and the unauthenticated
 * Login screen so a user can switch themes before signing in and have the
 * choice carry through into the authenticated session.
 */
export function useTheme() {
  const [theme, setTheme] = useState<Theme>(() =>
    localStorage.getItem(STORAGE_KEY) === 'dark' ? 'dark' : 'light'
  )

  useEffect(() => {
    document.documentElement.dataset['theme'] = theme
    localStorage.setItem(STORAGE_KEY, theme)
  }, [theme])

  function toggleTheme() {
    setTheme(th => (th === 'light' ? 'dark' : 'light'))
  }

  return { theme, toggleTheme }
}
